export const DESCRIPTION_LINE_HEIGHT_PX = 20
export const DESCRIPTION_MAX_LINES = 3
export const DESCRIPTION_COLLAPSED_HEIGHT_PX = DESCRIPTION_LINE_HEIGHT_PX * DESCRIPTION_MAX_LINES

export const DESCRIPTION_LINE_HEIGHT_REM = '2rem'
export const DESCRIPTION_COLLAPSED_HEIGHT_REM = '6rem'
